// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__1sONB","content":"GlobalSearch_content__2m_tf"};